export const buttonSizes = {
   ['Small']: {
      padding: 'p-[8px]',
      borderRadius: 'rounded-lg',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['Medium']: {
      padding: 'p-[10px]',
      borderRadius: 'rounded-lg',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['Large']: {
      padding: 'p-[12px]',
      borderRadius: 'rounded-10px',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['ExtraLarge']: {
      padding: 'p-[14px]',
      borderRadius: 'rounded-10px',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['DoubleExtraLarge']: {
      padding: 'p-[16px]',
      borderRadius: 'rounded-xl',
      iconSize: {
         width: 24,
         height: 24
      }
   }
}
